
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

/** Import UIkit */
import UIkit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Swal from 'sweetalert2';
import Select2 from 'select2';
import tinymce from 'tinymce/tinymce';

// A theme is also required
require('tinymce/themes/silver/theme');

// Any plugins you want to use has to be imported
require('tinymce/plugins/paste');
require('tinymce/plugins/image');
require('tinymce/plugins/code');
/** Load Icons */
UIkit.use(Icons);

window.jQuery = jQuery;
window.UIkit = UIkit;
window.Swal = Swal ;
window.Chart = Chart;
window.ChartDataLabels = ChartDataLabels;
window.tinymce = tinymce ;
window.select2 - Select2;

$('.select2box').select2();
// });
